export default "__VITE_ASSET__Dzhl37Q2__"